import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useOpsAuth } from "./OpsAuthContext";
import { fmtErr } from "./opsApi";
import { Lock } from "lucide-react";

export default function OpsLogin() {
  const { user, login } = useOpsAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/ops" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); navigate("/ops", { replace: true }); }
    catch (e2) { setErr(fmtErr(e2?.response?.data?.detail) || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#1a0707] p-4">
      <form onSubmit={submit} data-testid="ops-login-form" className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#241010] p-8 shadow-2xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#AC3333] text-white"><Lock className="h-5 w-5" /></div>
          <div><h1 className="font-serif text-lg font-bold text-white">Panel de Operaciones</h1><p className="text-xs text-white/50">Acceso interno · equipo</p></div>
        </div>
        {err && <div data-testid="ops-login-error" className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-300">{err}</div>}
        <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-white/50">Email</label>
        <input data-testid="ops-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mb-4 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2.5 text-sm text-white outline-none focus:border-[#AC3333]" required />
        <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-white/50">Contraseña</label>
        <input data-testid="ops-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mb-6 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2.5 text-sm text-white outline-none focus:border-[#AC3333]" required />
        <button data-testid="ops-login-submit" disabled={busy} className="w-full rounded-lg bg-[#AC3333] py-2.5 text-sm font-semibold text-white hover:bg-[#FF0505] disabled:opacity-60">{busy ? "Entrando…" : "Entrar"}</button>
      </form>
    </div>
  );
}
